import React from "react";
import "./EventsText.css";

export default function EventsText() {
  return (
    <div className="events-container">
      <div className="sentence">
        <span>Experience</span>
<div className="roller">
  <ul>
    <li>Meetings</li>
    <li>Incentive Tours</li>
    <li>Conferences</li>
    <li>Exhibitions</li>
    <li><strong>MICE</strong></li>
  </ul>
</div>
<span>redefined.</span>
      </div>
    </div>
  );
}
